/**
 * This file may contain code that utilizes generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub CoPilot, OpenAI ChatGPT or others.
 */
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import { mobileTicket } from '../api';

export const useTicketPdfContext = ({ ticketRef } = {}) => {
  const { entityRef } = useParams();
  const query = useQuery({
    queryKey: ['ticketPdfContext', entityRef, ticketRef],
    queryFn: () => mobileTicket.getTicketPdfContext({ entityRef, ticketRef }),
    enabled: !!entityRef && !!ticketRef,
    staleTime: Infinity,
  });

  return {
    ...query,
    context: query.data?.context,
  };
};
